import React, { Suspense } from "react";
import Header from "../Mainpage/HomePage/Header";
import { Route, Routes, Navigate } from "react-router-dom";
import Canvas from "../Mainpage/HomePage/Canvas";
import About from "../Mainpage/HomePage/About";
import SEO from "../SEO/SEO";
import SEOContentSection from "../SEO/SEOContentSection";
import PageWrapper from "../utils/PageWrapper";

// Lazy-loaded tool pages for code splitting
const PdfToPng = React.lazy(() => import("../pages/Pdf/PngToPdf/PngToPdf"));
const ImageToPdf = React.lazy(() => import("../pages/Pdf/ImagetoPdf/ImageToPdf"));
const JpgToPdf = React.lazy(() => import("../pages/Pdf/JpgToPdf/JpgToPdf"));
const PngToPdf = React.lazy(() => import("../pages/Pdf/PngToPdf/PngToPdf"));
const PdfToGif = React.lazy(() => import("../pages/Pdf/PdfToGif/PdfToGif"));
const PdfConverter = React.lazy(() => import("../pages/Pdf/PdfConverter/PdfConverter"));
const CompareText = React.lazy(() => import("../pages/Pdf/CompareText/CompareText"));
const JsonEditorApp = React.lazy(() => import("../pages/Pdf/JsonEditorApp/JsonEditorApp"));
const PdfToExcel = React.lazy(() => import("../pages/Pdf/PdfToExcel/PdfToExcel"));
const PdfToJson = React.lazy(() => import("../pages/Pdf/PdfToJson/PdfToJson"));
const PdfToWord = React.lazy(() => import("../pages/Pdf/pdfToword/PdfToWord"));
const PdfToCsv = React.lazy(() => import("../pages/Pdf/PdfToCsv/PdfToCsv"));
const PdfToPpt = React.lazy(() => import("../pages/Pdf/PdfToPpt/PdfToPpt"));
const PdfToDocx = React.lazy(() => import("../pages/Pdf/PdfToDocx/PdfToDocx"));
const PdfToTxt = React.lazy(() => import("../pages/Pdf/PdfToTxt/PdfToTxt"));
const PdfToPptx = React.lazy(() => import("../pages/Pdf/PdfToPptx/PdfToPptx"));
const PdfToRtf = React.lazy(() => import("../pages/Pdf/PdfToRtf/PdfToRtf"));
const PdfTools = React.lazy(() => import("../pages/Pdf/AllPdfTools/PdfTools"));
const MergePDFs = React.lazy(() => import("../pages/Pdf/MergePDFs/MergePDFs"));
const SplitPDF = React.lazy(() => import("../pages/Pdf/SplitPDF/SplitPDF"));
const EditPDFMetadata = React.lazy(() => import("../pages/Pdf/EditPDFMetadata/EditPDFMetadata"));
const AnnotatePDF = React.lazy(() => import("../pages/Pdf/AnnotatePDF/AnnotatePDF"));
const PDFEditor = React.lazy(() => import("../pages/Pdf/PDFEditor/PDFEditor"));
const NotFound = React.lazy(() => import("../pages/NotFound/NotFound"));

const LoadingFallback = () => (
    <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#323232]"></div>
    </div>
);

function Router() {
    return (
        <PageWrapper>
        <div className="min-h-screen flex flex-col justify-between">
            <Header />
                <div className="bg-background gap-y-5 overflow-hidden flex flex-wrap w-100">
                    <main style={{width: "100%"}} role="main">
                    <Suspense fallback={<LoadingFallback />}>
                    <Routes>
                        {/* English Routes */}
                        <Route path="/" element={
                            <>
                                <SEO pageType="home" url="/" lang="en" />
                                <PdfTools />
                                <SEOContentSection pageType="home" />
                            </>
                        } />
                        <Route path="/PdfConverter" element={
                            <>
                                <SEO pageType="pdfConverter" url="/PdfConverter" lang="en" />
                                <PdfConverter />
                                <SEOContentSection pageType="pdfConverter" />
                            </>
                        } />
                        <Route path="/PdfToPng" element={
                            <>
                                <SEO pageType="pdfToPng" url="/PdfToPng" lang="en" />
                                <PdfToPng />
                                <SEOContentSection pageType="pdfToPng" />
                            </>
                        } />
                        <Route path="/ImageToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/ImageToPdf" lang="en" />
                                <ImageToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/JpgToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/JpgToPdf" lang="en" />
                                <JpgToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/PngToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/PngToPdf" lang="en" />
                                <PngToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/PdfToGif" element={
                            <>
                                <SEO pageType="pdfToGif" url="/PdfToGif" lang="en" />
                                <PdfToGif />
                                <SEOContentSection pageType="pdfToGif" />
                            </>
                        } />
                        <Route path="/CompareText" element={
                            <>
                                <SEO pageType="compareText" url="/CompareText" lang="en" />
                                <CompareText />
                                <SEOContentSection pageType="compareText" />
                            </>
                        } />
                        <Route path="/JsonEditorApp" element={
                            <>
                                <SEO pageType="jsonEditor" url="/JsonEditorApp" lang="en" />
                                <JsonEditorApp />
                                <SEOContentSection pageType="jsonEditor" />
                            </>
                        } />
                        <Route path="/PdfToExcel" element={
                            <>
                                <SEO pageType="pdfToExcel" url="/PdfToExcel" lang="en" />
                                <PdfToExcel />
                                <SEOContentSection pageType="pdfToExcel" />
                            </>
                        } />
                        <Route path="/PdfToJson" element={
                            <>
                                <SEO pageType="pdfToJson" url="/PdfToJson" lang="en" />
                                <PdfToJson />
                                <SEOContentSection pageType="pdfToJson" />
                            </>
                        } />
                        <Route path="/PdfToWord" element={
                            <>
                                <SEO pageType="pdfToWord" url="/PdfToWord" lang="en" />
                                <PdfToWord />
                                <SEOContentSection pageType="pdfToWord" />
                            </>
                        } />
                        <Route path="/PdfToCsv" element={
                            <>
                                <SEO pageType="pdfToCsv" url="/PdfToCsv" lang="en" />
                                <PdfToCsv />
                                <SEOContentSection pageType="pdfToCsv" />
                            </>
                        } />
                        <Route path="/PdfToPpt" element={
                            <>
                                <SEO pageType="pdfToPpt" url="/PdfToPpt" lang="en" />
                                <PdfToPpt />
                                <SEOContentSection pageType="pdfToPpt" />
                            </>
                        } />
                        <Route path="/PdfToRtf" element={
                            <>
                                <SEO pageType="pdfToRtf" url="/PdfToRtf" lang="en" />
                                <PdfToRtf />
                                <SEOContentSection pageType="pdfToRtf" />
                            </>
                        } />
                        <Route path="/PdfToPptx" element={
                            <>
                                <SEO pageType="pdfToPptx" url="/PdfToPptx" lang="en" />
                                <PdfToPptx />
                                <SEOContentSection pageType="pdfToPptx" />
                            </>
                        } />
                        <Route path="/PdfToTxt" element={
                            <>
                                <SEO pageType="pdfToTxt" url="/PdfToTxt" lang="en" />
                                <PdfToTxt />
                                <SEOContentSection pageType="pdfToTxt" />
                            </>
                        } />
                        <Route path="/PdfToDocx" element={
                            <>
                                <SEO pageType="pdfToDocx" url="/PdfToDocx" lang="en" />
                                <PdfToDocx />
                                <SEOContentSection pageType="pdfToDocx" />
                            </>
                        } />
                        <Route path="/MergePDFs" element={
                            <>
                                <SEO pageType="mergePDF" url="/MergePDFs" lang="en" />
                                <MergePDFs />
                                <SEOContentSection pageType="mergePDF" />
                            </>
                        } />
                        <Route path="/SplitPDF" element={
                            <>
                                <SEO pageType="splitPDF" url="/SplitPDF" lang="en" />
                                <SplitPDF />
                                <SEOContentSection pageType="splitPDF" />
                            </>
                        } />
                        <Route path="/EditPDFMetadata" element={
                            <>
                                <SEO pageType="editPdfMetadata" url="/EditPDFMetadata" lang="en" />
                                <EditPDFMetadata />
                                <SEOContentSection pageType="editPdfMetadata" />
                            </>
                        } />
                        <Route path="/AnnotatePDF" element={
                            <>
                                <SEO pageType="annotatePdf" url="/AnnotatePDF" lang="en" />
                                <AnnotatePDF />
                                <SEOContentSection pageType="annotatePdf" />
                            </>
                        } />
                        <Route path="/PDFEditor" element={
                            <>
                                <SEO pageType="pdfEditor" url="/PDFEditor" lang="en" />
                                <PDFEditor />
                                <SEOContentSection pageType="pdfEditor" />
                            </>
                        } />

                        {/* French Routes */}
                        <Route path="/fr" element={
                            <>
                                <SEO pageType="home" url="/fr" lang="fr" />
                                <PdfTools />
                                <SEOContentSection pageType="home" />
                            </>
                        } />
                        <Route path="/fr/PdfConverter" element={
                            <>
                                <SEO pageType="pdfConverter" url="/fr/PdfConverter" lang="fr" />
                                <PdfConverter />
                                <SEOContentSection pageType="pdfConverter" />
                            </>
                        } />
                        <Route path="/fr/PdfToPng" element={
                            <>
                                <SEO pageType="pdfToPng" url="/fr/PdfToPng" lang="fr" />
                                <PdfToPng />
                                <SEOContentSection pageType="pdfToPng" />
                            </>
                        } />
                        <Route path="/fr/ImageToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/fr/ImageToPdf" lang="fr" />
                                <ImageToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/fr/JpgToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/fr/JpgToPdf" lang="fr" />
                                <JpgToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/fr/PngToPdf" element={
                            <>
                                <SEO pageType="imageToPdf" url="/fr/PngToPdf" lang="fr" />
                                <PngToPdf />
                                <SEOContentSection pageType="imageToPdf" />
                            </>
                        } />
                        <Route path="/fr/PdfToGif" element={
                            <>
                                <SEO pageType="pdfToGif" url="/fr/PdfToGif" lang="fr" />
                                <PdfToGif />
                                <SEOContentSection pageType="pdfToGif" />
                            </>
                        } />
                        <Route path="/fr/CompareText" element={
                            <>
                                <SEO pageType="compareText" url="/fr/CompareText" lang="fr" />
                                <CompareText />
                                <SEOContentSection pageType="compareText" />
                            </>
                        } />
                        <Route path="/fr/JsonEditorApp" element={
                            <>
                                <SEO pageType="jsonEditor" url="/fr/JsonEditorApp" lang="fr" />
                                <JsonEditorApp />
                                <SEOContentSection pageType="jsonEditor" />
                            </>
                        } />
                        <Route path="/fr/PdfToExcel" element={
                            <>
                                <SEO pageType="pdfToExcel" url="/fr/PdfToExcel" lang="fr" />
                                <PdfToExcel />
                                <SEOContentSection pageType="pdfToExcel" />
                            </>
                        } />
                        <Route path="/fr/PdfToJson" element={
                            <>
                                <SEO pageType="pdfToJson" url="/fr/PdfToJson" lang="fr" />
                                <PdfToJson />
                                <SEOContentSection pageType="pdfToJson" />
                            </>
                        } />
                        <Route path="/fr/PdfToWord" element={
                            <>
                                <SEO pageType="pdfToWord" url="/fr/PdfToWord" lang="fr" />
                                <PdfToWord />
                                <SEOContentSection pageType="pdfToWord" />
                            </>
                        } />
                        <Route path="/fr/PdfToCsv" element={
                            <>
                                <SEO pageType="pdfToCsv" url="/fr/PdfToCsv" lang="fr" />
                                <PdfToCsv />
                                <SEOContentSection pageType="pdfToCsv" />
                            </>
                        } />
                        <Route path="/fr/PdfToPpt" element={
                            <>
                                <SEO pageType="pdfToPpt" url="/fr/PdfToPpt" lang="fr" />
                                <PdfToPpt />
                                <SEOContentSection pageType="pdfToPpt" />
                            </>
                        } />
                        <Route path="/fr/PdfToRtf" element={
                            <>
                                <SEO pageType="pdfToRtf" url="/fr/PdfToRtf" lang="fr" />
                                <PdfToRtf />
                                <SEOContentSection pageType="pdfToRtf" />
                            </>
                        } />
                        <Route path="/fr/PdfToPptx" element={
                            <>
                                <SEO pageType="pdfToPptx" url="/fr/PdfToPptx" lang="fr" />
                                <PdfToPptx />
                                <SEOContentSection pageType="pdfToPptx" />
                            </>
                        } />
                        <Route path="/fr/PdfToTxt" element={
                            <>
                                <SEO pageType="pdfToTxt" url="/fr/PdfToTxt" lang="fr" />
                                <PdfToTxt />
                                <SEOContentSection pageType="pdfToTxt" />
                            </>
                        } />
                        <Route path="/fr/PdfToDocx" element={
                            <>
                                <SEO pageType="pdfToDocx" url="/fr/PdfToDocx" lang="fr" />
                                <PdfToDocx />
                                <SEOContentSection pageType="pdfToDocx" />
                            </>
                        } />
                        <Route path="/fr/MergePDFs" element={
                            <>
                                <SEO pageType="mergePDF" url="/fr/MergePDFs" lang="fr" />
                                <MergePDFs />
                                <SEOContentSection pageType="mergePDF" />
                            </>
                        } />
                        <Route path="/fr/SplitPDF" element={
                            <>
                                <SEO pageType="splitPDF" url="/fr/SplitPDF" lang="fr" />
                                <SplitPDF />
                                <SEOContentSection pageType="splitPDF" />
                            </>
                        } />
                        <Route path="/fr/EditPDFMetadata" element={
                            <>
                                <SEO pageType="editPdfMetadata" url="/fr/EditPDFMetadata" lang="fr" />
                                <EditPDFMetadata />
                                <SEOContentSection pageType="editPdfMetadata" />
                            </>
                        } />
                        <Route path="/fr/AnnotatePDF" element={
                            <>
                                <SEO pageType="annotatePdf" url="/fr/AnnotatePDF" lang="fr" />
                                <AnnotatePDF />
                                <SEOContentSection pageType="annotatePdf" />
                            </>
                        } />
                        <Route path="/fr/PDFEditor" element={
                            <>
                                <SEO pageType="pdfEditor" url="/fr/PDFEditor" lang="fr" />
                                <PDFEditor />
                                <SEOContentSection pageType="pdfEditor" />
                            </>
                        } />

                        {/* SEO-friendly hyphenated URL aliases */}
                        <Route path="/pdf-converter" element={<Navigate to="/PdfConverter" replace />} />
                        <Route path="/pdf-to-png" element={<Navigate to="/PdfToPng" replace />} />
                        <Route path="/image-to-pdf" element={<Navigate to="/ImageToPdf" replace />} />
                        <Route path="/jpg-to-pdf" element={<Navigate to="/JpgToPdf" replace />} />
                        <Route path="/png-to-pdf" element={<Navigate to="/PngToPdf" replace />} />
                        <Route path="/pdf-to-gif" element={<Navigate to="/PdfToGif" replace />} />
                        <Route path="/compare-text" element={<Navigate to="/CompareText" replace />} />
                        <Route path="/json-editor" element={<Navigate to="/JsonEditorApp" replace />} />
                        <Route path="/pdf-to-excel" element={<Navigate to="/PdfToExcel" replace />} />
                        <Route path="/pdf-to-json" element={<Navigate to="/PdfToJson" replace />} />
                        <Route path="/pdf-to-word" element={<Navigate to="/PdfToWord" replace />} />
                        <Route path="/pdf-to-csv" element={<Navigate to="/PdfToCsv" replace />} />
                        <Route path="/pdf-to-ppt" element={<Navigate to="/PdfToPpt" replace />} />
                        <Route path="/pdf-to-rtf" element={<Navigate to="/PdfToRtf" replace />} />
                        <Route path="/pdf-to-pptx" element={<Navigate to="/PdfToPptx" replace />} />
                        <Route path="/pdf-to-txt" element={<Navigate to="/PdfToTxt" replace />} />
                        <Route path="/pdf-to-docx" element={<Navigate to="/PdfToDocx" replace />} />
                        <Route path="/merge-pdfs" element={<Navigate to="/MergePDFs" replace />} />
                        <Route path="/split-pdf" element={<Navigate to="/SplitPDF" replace />} />
                        <Route path="/edit-pdf-metadata" element={<Navigate to="/EditPDFMetadata" replace />} />
                        <Route path="/annotate-pdf" element={<Navigate to="/AnnotatePDF" replace />} />
                        <Route path="/pdf-editor" element={<Navigate to="/PDFEditor" replace />} />

                        {/* 404 Catch-all */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    </Suspense>
                </main>
                <div>
                    <div className="h-1">
                        <Canvas />
                    </div>
                        <div style={{ marginBottom: "0px" }}>
                        <About />
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    )
}
export default Router;